module.exports = __webpack_public_path__ + "img/originator-sunweiya.4021d8c6.png";